import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71bbb88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-box h-full w-full overflow-y-auto max-w-14xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 忘记密码 ", -1))
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = { class: "email-validate-box" }
const _hoisted_5 = { class: "button-box" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 重置密码 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 返回登录页 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_input = _resolveComponent("f-input")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_f_input, {
        modelValue: _ctx.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        label: "学邮",
        autofocus: "",
        clearable: "",
        outlined: "",
        required: "",
        suffix: "@fudan.edu.cn",
        rules: [(v) => !!v || '学邮不能为空', (v) => /^\d{11}$/.test(v) || '请输入11位学号']
      }, null, 8, ["modelValue", "rules"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_f_input, {
          modelValue: _ctx.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code) = $event)),
          label: "验证码",
          hint: "若有未使用的码，可直接填写",
          outlined: "",
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_f_button, {
          type: "primary",
          disabled: _ctx.cooldownCnt !== 0,
          loading: _ctx.state === 'requesting',
          onClick: _ctx.requestCode
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.state === 'init' || _ctx.state === 'requesting'
              ? '发送验证码'
              : _ctx.state === 'cooldown'
                ? `${_ctx.cooldownCnt}s`
                : '重新发送'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      _createVNode(_component_f_input, {
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
        type: "password",
        label: "新的密码",
        clearable: "",
        outlined: "",
        required: "",
        rules: [(v) => !!v || '密码不能为空']
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_component_f_input, {
        modelValue: _ctx.password2,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password2) = $event)),
        type: "password",
        label: "再次输入新密码",
        clearable: "",
        outlined: "",
        required: "",
        rules: [(v) => !!v || '密码不能为空']
      }, null, 8, ["modelValue", "rules"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_f_button, {
        class: "w-full",
        type: "primary",
        size: "large",
        shape: "circle",
        onClick: _ctx.resetPassword
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_f_button, {
      style: {"margin-top":"12px"},
      type: "link",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/login')))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}